import styled from "styled-components";

export const Wrapper = styled.div`
  height: ${({ isPreview }) => (isPreview ? "calc(100% - 50px)" : "100%")};
  overflow: hidden;

  ${({ isPreview }) => {
    if (isPreview) {
      return `
        min-height: 500px;
        padding-bottom: 50px;

        .p-organizationchart-table {
          cursor: grab;

          &:active {
            cursor: grabbing;
          }
        }
    `;
    }
  }}

  .p-node-toggler {
    ${({ isPreview }) => {
      if (!isPreview) {
        return "left: calc(50% - 28px);";
      }
    }}
  }

  .p-organizationchart-node-content {
    span {
      color: ${({ theme }) => theme.text.text};
    }
  }

  .p-organizationchart > .p-organizationchart-table:first-child > tbody {
    ${({ hasMultipleFirstLevelNodes }) => {
      return `
          & > tr:nth-child(-n + ${hasMultipleFirstLevelNodes ? "2" : "3"}) {
            visibility: hidden !important;
          }
        `;
    }}
  }

  .p-organizationchart-line-down {
    width: 2px;
    background-color: ${({ connectingLineColor }) => connectingLineColor};
  }

  .p-organizationchart-lines {
    .p-organizationchart-line-right.p-organizationchart-line-top:not(:nth-child(2)):not(:nth-last-child(2)) {
      border-top: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
      border-left: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
    }
    .p-organizationchart-line-left.p-organizationchart-line-top:not(:nth-child(2)):not(:nth-last-child(2)) {
      border-top: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
      border-right: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
    }

    .p-organizationchart-line-right.p-organizationchart-line-top:not(:not(:nth-child(2)):not(:nth-last-child(2))) {
      border-top: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
      border-left: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
    }
    .p-organizationchart-line-left.p-organizationchart-line-top:not(:not(:nth-child(2)):not(:nth-last-child(2))) {
      border-top: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
      border-right: ${({ connectingLineColor }) =>
        `2px solid ${connectingLineColor}`};
    }
  }
`;
